import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as FiIcons from 'react-icons/fi';
import {
  Flex, Text,
  Accordion, AccordionItem, Box
} from '@chakra-ui/react';
import { toggleSidebar } from '../../../store/sidebar/sidebarSlice';
import { Overlay, Wrapper } from './Styles';

const Sidebar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const sidebar = useSelector(state => state.sidebar);
  const auth = useSelector(state => state.auth);

  const permissions = auth.user?.role?.permissions ?? [];

  const closeSidebar = () => {
    dispatch(toggleSidebar());
  }

  return (
    <>
      {sidebar.isNotOpened && (
        <Overlay as={Box}
          className="sidebar-overlay" position="fixed" top="0" right="0" w="100%" h="100vh" bg="rgba(0, 0, 0, .5)" zIndex="99"
          role="button" onClick={() => dispatch(toggleSidebar())}
        />
      )}
      <Wrapper className={sidebar.isNotOpened ? 'active' : ''}>
        <Text
          textTransform="capitalize" mb={4} className="text"
          fontSize={16} color="#5e76a1" fontWeight="600"
        >
          {t('layout.sidebar.navigation')}
        </Text>

        <Box className="sidebar-links">
          <Accordion allowToggle={true} border="none">

            <AccordionItem border="none">
              <NavLink to="/admin" end onClick={closeSidebar} className="chakra-accordion__button">
                <Flex alignItems="center">
                  <span className="icon"><FiIcons.FiHome /></span>
                  <span className="text">{t('layout.sidebar.dashboard')}</span>
                </Flex>
              </NavLink>
            </AccordionItem>

            {permissions.includes('manage_settings') && (
              <AccordionItem border="none">
                <NavLink to="/admin/roles" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiShield /></span>
                    <span className="text">{t('layout.sidebar.roles')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_users') && (
              <AccordionItem border="none">
                <NavLink to="/admin/users" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiUsers /></span>
                    <span className="text">{t('layout.sidebar.users')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_servers') && (
              <AccordionItem border="none">
                <NavLink to="/admin/servers" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiServer /></span>
                    <span className="text">{t('layout.sidebar.servers')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_programmers') && (
              <AccordionItem border="none">
                <NavLink to="/admin/programmers" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiCode /></span>
                    <span className="text">{t('layout.sidebar.programmers', 'المبرمجين')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_designers') && (
              <AccordionItem border="none">
                <NavLink to="/admin/designers" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiEdit3 /></span>
                    <span className="text">{t('layout.sidebar.designers', 'المصممين')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_beta_testers') && (
              <AccordionItem border="none">
                <NavLink to="/admin/beta-testers" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiUserCheck /></span>
                    <span className="text">{t('layout.sidebar.beta_testers', 'لاعبين بيتا')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_videos') && (
              <AccordionItem border="none">
                <NavLink to="/admin/videos" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiVideo /></span>
                    <span className="text">{t('layout.sidebar.videos')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_content_creators') && (
              <AccordionItem border="none">
                <NavLink to="/admin/content-creators" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiStar /></span>
                    <span className="text">{t('layout.sidebar.content_creators')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_shop') && (
              <AccordionItem border="none">
                <NavLink to="/admin/shop" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiShoppingCart /></span>
                    <span className="text">{t('layout.sidebar.shop')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_shop') && (
              <AccordionItem border="none">
                <NavLink to="/admin/shop-offers" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiTag /></span>
                    <span className="text">{t('layout.sidebar.shop_offers', 'عروض المطلوبات')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_transactions') && (
              <AccordionItem border="none">
                <NavLink to="/admin/transactions" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiCreditCard /></span>
                    <span className="text">{t('layout.sidebar.transactions', 'المعاملات المالية')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_services') && (
              <AccordionItem border="none">
                <NavLink to="/admin/services" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiTool /></span>
                    <span className="text">{t('layout.sidebar.services')}</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

            {permissions.includes('manage_settings') && (
              <AccordionItem border="none">
                <NavLink to="/admin/settings" onClick={closeSidebar} className="chakra-accordion__button">
                  <Flex alignItems="center">
                    <span className="icon"><FiIcons.FiSettings /></span>
                    <span className="text">إعدادات المجتمع</span>
                  </Flex>
                </NavLink>
              </AccordionItem>
            )}

          </Accordion>
        </Box>
      </Wrapper>
    </>
  )
}

export default Sidebar
